/**
 * Vendor
 */
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

/**
 * CARIBE7 MODULES
 */
import BaseService  from '@shared/services/base/BaseService'

/**
 * Alert Service
 *
 * @class      BaseAlertService (name)
 */
function BaseAlertService(component) {
  this.component      = component;
  this.swal_promise   = null;
}

BaseAlertService.prototype = Object.assign(BaseAlertService.prototype, BaseService.prototype);

/**
 * Creates a swal react.
 *
 * @return     {Swal Instance}
 */
BaseAlertService.prototype.createSwalReact = function() {
  return withReactContent(Swal);
}

/**
 * Prepares swal props
 */
BaseAlertService.prototype.prepareSwalProps = function(props={}, options={}) {
  Object.assign(props, this.defaults_props);
  return Object.assign(props, options);
}

/**
 * Creates a swal.
 *
 * @param      {Object}    arg1             The argument 1
 * @param      {Object}    [arg1.props={}]  The properties
 * @param      {function}  arg1.onConfirm   On confirm
 * @param      {function}  arg1.onDenied    On denied
 * @param      {function}  arg1.onResolve   On resolve
 * @param      {function}  arg1.onError     On error
 */
BaseAlertService.prototype.createSwal = function({
  props = {},
  options = {},
  onConfirm,
  onDenied,
  onResolve,
  onError
}) {
  let swal_props    = this.prepareSwalProps(props, options);
  this.swal_promise = this.createSwalReact().fire(swal_props);
  this.bindCallbacks({
    onConfirm: onConfirm,
    onResolve: onResolve,
    onDenied:  onDenied,
    onError:   onError,
  });
}

/**
 * Bind alert callbacks
 *
 * @param      {Object}    arg1            The argument 1
 * @param      {function}  arg1.onConfirm  On confirm
 * @param      {Function}  arg1.onDenied   On denied
 * @param      {function}  arg1.onResolve  On resolve
 * @param      {function}  arg1.onError    On error
 */
BaseAlertService.prototype.bindCallbacks = function({
  onConfirm, onDenied, onResolve, onError
}) {
  /**
   * Filter
   */
  if (typeof onConfirm != 'function') { onConfirm = null }
  if (typeof onDenied  != 'function') { onDenied = null }
  if (typeof onResolve != 'function') { onResolve = null }
  if (typeof onError   != 'function') { onError = null }

  /**
   * Callback
   */
  this.swal_promise.then(result => {
    if(result.isConfirmed)
        onConfirm && onConfirm(result);

    if(result.isDenied)
        onDenied && onDenied(result);

    onResolve && onResolve(result);
  }).catch(error => onError && onError(error));
};

export default BaseAlertService;